import styled from 'styled-components'

export const Container = styled.div`
    position: absolute;
    display: flex;
    background-color: #fff;
    max-height: 20vh;
    top: 5.3vh;
    white-space: break-spaces;
    overflow-y: auto;
    overflow-x: hidden;
    flex-direction: column;
    border: 1px solid #ebebeb;
    z-index: 1;
`
    
    export const FieldDiv = styled.div`
    display: flex;
    height: 5vh;
    justify-content: center;
    padding: .75rem;
    align-items: center;
    cursor: pointer;
    
    :hover{
        background-color: #f5f5f5;
    }
`
        
export const FieldText = styled.p`
    font-size: 0.8vw;
`
